module.exports = __webpack_public_path__ + "static/media/connect-linear-middle-dark.f0a30165.svg";